<template>
  <div>
    <v-list>
      <ListItem
        :title="schoolType.name"
        :subtitle="$t('fields.name')"
      />
      <ListItem
        :title="schoolType.alias"
        :subtitle="$t('fields.alias')"
      />
      <ListItem
        :title="schoolType.code"
        :subtitle="$t('fields.code')"
      />
      <ListItem
        :title="schoolType.grouped"
        :subtitle="$t('fields.grouped')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'SchoolTypeDetails',
    components: { ListItem },
    props: {
      schoolType: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
